export const ADMIN_ROLES = ['org_admin', 'ops_admin'] as const;
export const ALL_ROLES = ['org_admin', 'ops_admin', 'app_developer'] as const;

export function isAdminOrOps(role?: string): boolean {
  return role === 'org_admin' || role === 'ops_admin';
}
